<template>
  <div class="container" style="background: #f8f8f8">
    <!-- 顶部大图展示 -->
    <div id="banner" ref="banner">
      <div class="step-title">
        <h2 class="topTitle">未来·共赢</h2>
        <p class="topTitleSub">
          依托雄厚的渠道资源，做好全面的技术服务，打造适合中国的大屏端开放平台
        </p>
      </div>
    </div>
    <div class="main">
      <!-- 功能与服务 -->
      <div class="step step0">
        <div class="step-title">
          <p class="titleEnglish">Function and service</p>
          <h2 class="topTitle">功能与服务</h2>
          <p class="topTitleSub">
            以大屏端为中心，打造绿色、安全、可管、可控的生态体系
          </p>
        </div>
        <div
          style="
            width: 20px;
            height: 2px;
            background: #4d7af0;
            border-radius: 1px;
            margin-left: 50%;
          "
        ></div>
        <div class="bgImg">
          <p v-for="item in 6">
            <span class="dian" v-for="item in 12">·</span>
          </p>
        </div>
        <div class="bgImg1">
          <p v-for="item in 6">
            <span class="dian" v-for="item in 12">·</span>
          </p>
        </div>
        <div class="bgImg2">
          <p v-for="item in 6">
            <span class="dian" v-for="item in 12">·</span>
          </p>
        </div>
        <el-row class="step0row row-bg" type="flex" justify="space-around">
          <el-col
            class="step0col"
            v-for="item in step0"
            :span="6"
            :key="item.key"
          >
            <dl>
              <dt>
                <img
                  :src="item.src"
                  :class="item.key === 1 ? 'transitionDiv' : ''"
                />
              </dt>
              <dd class="title" v-html="item.describe"></dd>
              <dd
                style="
                  width: 28px;
                  height: 2px;
                  background: #4d7af0;
                  border-radius: 1px;
                "
              ></dd>
              <dd class="title1" v-html="item.describe1"></dd>
            </dl>
          </el-col>
        </el-row>
      </div>
      <!-- 未来全渠道开放 -->
      <div class="step step2">
        <div class="step-title">
          <p class="titleEnglish">All channel opening</p>
          <h2 class="topTitle">未来全渠道开放</h2>
          <p class="topTitleSub">
            一次接入，全渠道覆盖，提供全方位的平台支持、多样化的盈利模式
          </p>
        </div>
        <div
          style="
            width: 20px;
            height: 2px;
            background: #4d7af0;
            border-radius: 1px;
            margin-left: 50%;
          "
        ></div>
        <el-row class="step2row">
          <el-col v-for="item in step2" :span="8" :key="item.key">
            <dl>
              <dt>
                <img
                  :src="item.src"
                  :class="item.key === 1 ? 'transitionDiv' : ''"
                />
              </dt>
              <dd class="title" v-html="item.describe"></dd>
            </dl>
          </el-col>
        </el-row>
      </div>
      <!-- 开发者服务 -->
      <div class="step step6">
        <div class="step-title">
          <p class="titleEnglish">Developer services</p>
          <h2 class="topTitle">开发者服务</h2>
          <p class="topTitleSub">
            为开发者提供认证、数据、审核等各阶段服务
          </p>
        </div>
        <div
          style="
            width: 20px;
            height: 2px;
            background: #4d7af0;
            border-radius: 1px;
            margin-left: 50%;
          "
        ></div>
        <div class="bgImg">
          <p v-for="item in 6">
            <span class="dian" v-for="item in 12">·</span>
          </p>
        </div>
        <div class="bgImg1">
          <p v-for="item in 6">
            <span class="dian" v-for="item in 12">·</span>
          </p>
        </div>
        <el-row class="step6row row-bg" type="flex" justify="space-around">
          <el-col
            class="step6col"
            v-for="item in step6"
            :span="6"
            :key="item.key"
          >
            <dl>
              <dt>
                <img
                  :src="item.src"
                  :class="item.key === 1 ? 'transitionDiv' : ''"
                />
              </dt>
              <dd class="smallImg"><img :src="item.src1" /></dd>
              <dd class="title" v-html="item.describe"></dd>
              <dd class="title1" v-html="item.describe1"></dd>
            </dl>
          </el-col>
        </el-row>
      </div>
      <!-- 业务合作流程 -->
      <div class="step step3">
        <div class="content">
          <div class="step-title">
            <h2 class="topTitle">业务合作流程</h2>
            <p class="topTitleSub">方便快捷的接入开放平台，快速实现入驻</p>
          </div>
          <el-row>
            <template v-for="item in step3">
              <el-col :span="3" :key="item.key">
                <dl>
                  <dt><img :src="item.src" /></dt>
                  <dd class="title">{{ item.describe }}</dd>
                  <dd class="topNum">{{ item.key }}</dd>
                </dl>
              </el-col>
              <el-col v-if="item.key !== 4" :span="4" class="line">
                <div class="topArrows"></div>
              </el-col>
            </template>
          </el-row>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="step step4">
        <div class="step-title">
          <p class="titleEnglish">Cooperative Partner</p>
          <h2 class="topTitle">合作伙伴</h2>
        </div>
        <el-row>
          <el-col :span="4" v-for="item in step4" :key="item.key"
            ><img class="cooperation" :src="item.src" alt="" />
            <p>期待合作</p>
          </el-col>
        </el-row>
      </div>
      <div class="step step5">
        <h2 class="topTitle5" v-if="needLogin || flag">
          <span style="width: 70px; height: 2px; background: #ffffff"></span
          >欢迎入驻<span
            style="width: 70px; height: 2px; background: #ffffff"
          ></span>
        </h2>
        <div class="btn-box">
          <el-button round class="topButton1" @click="handleApplication" v-if="needLogin || flag"
            >即刻申请</el-button
          >
        </div>
      </div>
      <!-- 底部链接加版权信息 -->
      <div class="footer">
        <div class="footer-content">
          <img class="logo" :src="logo" alt="" />
          <div style="text-align: center">
            <p class="breadcrumb">
              <span class="spanWord" @click="sy">网站首页</span>
              <span>|</span>
              <span class="spanWord" @click="handleUs">关于我们</span>
              <span>|</span>
              <span class="spanWord" @click="handleUser">用户协议</span>
              <span>|</span>
              <span class="spanWord" @click="handlePrivacy">隐私协议</span>
              <span>|</span>
              <span class="spanWord" @click="handleContact">联系我们</span>
            </p>
            <div class="rightCopy">
              <p>广播电视节目制作经营许可证：（津）字第379号</p>
              <p>网络文化经营许可证：津网文[2016]1209-018号</p>
              <p>津ICP备12004891号</p>
            </div>
          </div>
          <img class="cord" :src="cord" alt="" />
        </div>
      </div>
    </div>
    <div
      @click="goTop"
      style="
        position: fixed;
        right: 0;
        bottom: 50%;
        width: 38px;
        height: 38px;
        background: #a5a7b5;
        text-align: center;
        line-height: 44px;
        border-radius: 50%;
      "
    >
      <img src="../../assets/home1-image/top.png" alt="" />
    </div>
  </div>
</template>

<script>
import logo from '@/assets/home1-image/logo.png'
import cord from '@/assets/home1-image/cord.png'
import banner from '@/assets/home1-image/banner.png'
import { getUserInfoNew1 } from '../../resource/api/index'

export default {
  name: 'home',
  data () {
    return {
      needLogin: false,
      login_url: '',
      flag: false, // 判断是否登录
      logo: logo,
      cord: cord,
      defaultImg: banner,
      step0: [
        {
          key: 1,
          src: require('../../assets/home1-image/db.png'),
          describe: '点播',
          describe1: '提供大屏端一站式音视频点播服务'
        },
        {
          key: 2,
          src: require('../../assets/home1-image/nrgl.png'),
          describe: '内容管理',
          describe1: '提供内容的精细化管理'
        },
        {
          key: 3,
          src: require('../../assets/home1-image/yygl.png'),
          describe: '应用管理',
          describe1: '提供创建、管理和一键打包服务'
        },
        {
          key: 4,
          src: require('../../assets/home1-image/lhcq.png'),
          describe: '联合产品',
          describe1: '播控赋能、可管可控、高流量、高转化'
        },
        {
          key: 5,
          src: require('../../assets/home1-image/yysd.png'),
          describe: '应用商店',
          describe1: '优质渠道、助力应用分发服务'
        }
      ],
      step2: [
        {
          key: 1,
          src: require('../../assets/home1-image/dpqd.png'),
          describe: '国内<span>2000+</span>万日活的大屏端渠道'
        },
        {
          key: 2,
          src: require('../../assets/home1-image/qgfg.png'),
          describe: '全面覆盖国内外主流电视品牌厂商'
        },
        {
          key: 3,
          src: require('../../assets/home1-image/hwyw.png'),
          describe: '海外业务覆盖欧美、东南亚等'
        }
      ],
      step3: [
        {
          key: 1,
          src: require('../../assets/home1-image/zcrz.png'),
          describe: '注册认证'
        },
        {
          key: 2,
          src: require('../../assets/home1-image/xzfw.png'),
          describe: '选择服务'
        },
        {
          key: 3,
          src: require('../../assets/home1-image/nrsh.png'),
          describe: '内容审核'
        },
        {
          key: 4,
          src: require('../../assets/home1-image/sy1.png'),
          describe: '获取收益'
        }
      ],
      step4: [
        {
          key: 1,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 2,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 3,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 4,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 5,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 6,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 7,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 8,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 9,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 10,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 11,
          src: require('../../assets/home1-image/tjimg.png')
        },
        {
          key: 12,
          src: require('../../assets/home1-image/tjimg.png')
        }
      ],

      step6: [
        {
          key: 1,
          src: require('../../assets/home1-image/rzimg.png'),
          src1: require('../../assets/home1-image/rz.png'),
          describe: '认证',
          describe1: '账户一键登录渠道全面覆盖'
        },
        {
          key: 2,
          src: require('../../assets/home1-image/tjimg.png'),
          src1: require('../../assets/home1-image/tj.png'),
          describe: '统计',
          describe1: '多维度数据服务强大的数据支撑'
        },
        {
          key: 3,
          src: require('../../assets/home1-image/shimg.png'),
          src1: require('../../assets/home1-image/sh.png'),
          describe: '审核',
          describe1: '可管可控全面技术支持'
        }
      ]
    }
  },
  created () {
    this.isLogin()
  },
  mounted () {},
  methods: {
    sy () {
      this.$router.replace('/')
    },
    handleUs () {
      this.$router.replace('/aboutUs')
    },
    handleUser () {
      this.$router.replace('/useragreement')
    },
    handlePrivacy () {
      this.$router.replace('/privacyPolicy')
    },
    handleContact () {
      this.$router.replace('/contactUs')
    },
    // 获取用户信息
    async isLogin () {
      try {
        const { redirect_url, errorCode } = await getUserInfoNew1()
        this.login_url = redirect_url
        if (errorCode == 0) {
          this.flag = true
        } else if (errorCode == 401) {
          this.needLogin = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 回到顶部
    goTop () {
      scrollTo(0, 0)
    },
    // 立即申请
    handleApplication () {
      // 判断是否登录
      if (this.flag) {
        // 判断是否为测试环境地址
        if (window.location.href.includes('stage-')) {
          window.location.href = 'https://stage-open.cloud.ottcn.com/console/'
        } else {
          window.location.href = 'https://open.cloud.ottcn.com/console/'
        }
      } else if (this.needLogin) {
        // 判断是否为测试环境地址
        if (window.location.href.includes('stage-')) {
           window.location.href ='https://stage-open.cloud.ottcn.com/common/register/1'
        } else {
          window.location.href = 'https://open.cloud.ottcn.com/common/register/1'
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "index";
</style>
